import React from "react";
import { SPECIAL_UNITS_LABELS } from "./labels";
import { formatNumber } from "helpers/getNumberFormats";
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteIcon from "@material-ui/icons/Delete";
import { ActionsButtons } from "components/CustomButtons/ActionsButtons";

const { headers } = SPECIAL_UNITS_LABELS;

export const columns = (onEdit, onDelete) => [
  {
    Header: headers.unit,
    accessor: "unit",
    filterable: true,
  },
  {
    Header: headers.unitType,
    accessor: "unitType",
    filterable: true,
  },
  {
    Header: headers.price,
    accessor: "price",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
    filterable: true,
  },
  {
    Header: headers.sale,
    accessor: "sale",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: headers.grossSale,
    accessor: "grossSale",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: headers.netSale,
    accessor: "netSale",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: headers.profit,
    accessor: "profit",
    Cell: ({ value }) => (
      <div style={{ color: value < 0 ? "red" : "inherit" }}>
        $ {formatNumber(value)}
      </div>
    ),
  },
  {
    Header: headers.distributionExpenses,
    accessor: "distributionExpenses",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: headers.adminExpenses,
    accessor: "adminExpenses",
    Cell: ({ value }) => <div>$ {formatNumber(value)}</div>,
  },
  {
    Header: headers.profitSharing1,
    accessor: "profitSharing1",
    Cell: ({ value }) => (
      <div style={{ color: value < 0 ? "red" : "inherit" }}>
        $ {formatNumber(value)}
      </div>
    ),
  },
  {
    Header: headers.profitSharing2,
    accessor: "profitSharing2",
    Cell: ({ value }) => (
      <div style={{ color: value < 0 ? "red" : "inherit" }}>
        $ {formatNumber(value)}
      </div>
    ),
  },
  {
    Header: headers.date,
    accessor: "date",
    filterable: true,
  },
  {
    Header: headers.actions,
    accessor: "actions",
    sortable: false,
    filterable: false,
    Cell: ({ original }) => (
      <ActionsButtons
        buttons={[
          { Icon: VisibilityIcon, color: 0, onClick: () => onEdit(original), tooltip: "Ver detalles" },
          { Icon: DeleteIcon, color: 3, onClick: () => onDelete(original), tooltip: "Eliminar" },
        ]}
      />
    ),
  },
];
